import { defineStore } from "pinia";
import { API_Rnumb_list, IRnumb } from "@/services/api/Rnumb/list";
import { getRuDate } from "@/helpers/dateUtils";

interface IUserVisitsStore {
  data: IRnumb[];
  isLoading: boolean;
}

interface IRnumbGrouped {
  label: string;
  additionalLabel?: string;
  list: IRnumb[];
}

export const useUserVisitsStore = defineStore({
  id: "userVisits",
  state: (): IUserVisitsStore => {
    return {
      isLoading: false,
      data: [],
    };
  },
  getters: {
    dataIsLoading: ({ isLoading }) => isLoading,
    upcomingVisits: ({ data }) => {
      return data.slice(0, 4);
    },
    allUpcomingVisits: ({ data }) => {
      return data;
    },
    allUpcomingVisitsGrouped: ({ data }): IRnumbGrouped[] => {
      const arr: IRnumbGrouped[] = [];
      let currDate = "";
      let currArr: IRnumb[] = [];

      const currentDate = getRuDate(new Date());
      const nextDayDate = getRuDate(new Date(new Date().getTime() + 86400000));

      data.forEach((e) => {
        const date = e.dat_bgn.split(" ")[0];
        if (!date) return;

        if (date !== currDate) {
          currDate = date;
          currArr = [];
          const obj: IRnumbGrouped = {
            label: currDate,
            list: currArr,
          };

          if (date == currentDate) obj.additionalLabel = "Сегодня";
          else if (date == nextDayDate) obj.additionalLabel = "Завтра";

          arr.push(obj);
        }

        currArr.push(e);
      });
      return arr;
    },
  },
  actions: {
    getUpcomingVisits() {
      this.isLoading = true;
      return new Promise<void>((resolve, reject) => {
        const toDate = new Date();
        toDate.setFullYear(toDate.getFullYear() + 1);

        API_Rnumb_list()
          .then((response) => {
            this.data.length = 0;
            response.forEach((e) => this.data.push(e));
            this.data.sort((a, b) =>
              `${a.dat_bgn}`.localeCompare(`${b.dat_bgn}`)
            );
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => (this.isLoading = false));
      });
    },
  },
});
